import axios from 'axios';
import axiosInstance from '../axiosInstance';
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import getHeadersformdata from './getHeaderFormdata'
import { HTTP_METHOD } from '../constants/httpMethod/HttpMethod';

const PAGE_SIZE = 15;
export const orderAction = (page, fdate, tdate, name, status, sort, column) => (dispatch, getState) => {
  const API_URL = localStorage.getItem('countryBackendUrl')

  const { sortColumn, sortDirection } = getState().orderlistSort;
  let url = API_URL + Url.ORDER_LIST;
  const queryParams = [];

  if (fdate) queryParams.push(`start_date=${fdate}`);
  if (tdate) queryParams.push(`end_date=${tdate}`);
  if (name) queryParams.push(`search=${name}`);
  if (status) queryParams.push(`status=${status}`);

  queryParams.push(`page=${page}`);
  queryParams.push(`page_size=${PAGE_SIZE}`);

  if (sort && column) {
    queryParams.push(`order_by=${column}`);
    queryParams.push(`order=${sort}`);
  } else if (sortColumn && sortDirection) {
    queryParams.push(`order_by=${sortColumn}`);
    queryParams.push(`order=${sortDirection}`);
  }

  url += `?${queryParams.join('&')}`;

  const options = {
    method: HTTP_METHOD.GET,
    headers: getHeaders(),
    url
  };
  return axiosInstance(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.GET_ORDER_LIST, payload: resp?.data })
      return resp
    } else { return null }
  })
    .catch(error => {
      errorHandler(error)
    })
}

//order list sorting
export const orderListSort = (column, direction) => dispatch => {
  dispatch({ type: types.ORDER_LIST_SORT, payload: { column, direction } });
}

// Searched data for Order Listing
export const orderListSearchInputAction = (params = {}) => dispatch => {
  dispatch({ type: types.ORDER_LIST_SEARCH_INPUT, payload: params })
}

// Page data for Order Listing
export const orderListPageInputAction = (params = {}) => dispatch => {
  dispatch({ type: types.ORDER_LIST_PAGE_INPUT, payload: params })
}

// Create Order status Post API

export const orderstatusAction = (params = {}) => dispatch => {
  const API_URL = localStorage.getItem('countryBackendUrl')
  const url = API_URL + Url.CREATE_ORDER_STATUS
  const options = {
    method: HTTP_METHOD.POST,
    ...(params && { data: params }),
    headers: getHeadersformdata(),
    url
  };
  return axiosInstance(options).then(resp => {
    if (resp.status === 200 || resp.status === 201) {
      dispatch({ type: types.POST_CREATE_ORDER_STATUS, payload: resp })
      return resp
    } else { return null }
  }).catch(error => {
    errorHandler(error)
  })
}
